import { Themes } from '@sainsburys-tech/bolt'
import { ArgosVocab, HabitatVocab } from '@sainsburys-tech/bolt-vocab-provider'

const BOLT_VERSION = '7.2.0'

// This file is used by both the client and the server.
// Do not include API keys or server functions, as these will be included in the client bundle.

export default {
  argos: {
    key: 'argos',
    salesChannel: 'argos',
    canonicalBase: 'https://www.argos.co.uk',
    theme: Themes.ArgosTheme,
    vocab: ArgosVocab,
    bolt: {
      url: `https://www.argos.co.uk/assets/bolt2/${BOLT_VERSION}/bolt.min.css`,
      namespace: 'bolt-v2'
    },
    features: {
      taxonomy: {
        vocabId: ''
      },
      addToTrolley: {
        modal: {
          enabled: true,
          hideExtras: false,
          hideCategories: false
        }
      },
      bestSellers: {
        enabled: true
      },
      wishlist: {
        enabled: true
      },
      productList: {
        forceClothingTemplate: false
      }
    }
  },
  habitat: {
    key: 'habitat',
    salesChannel: 'habitat',
    canonicalBase: 'https://www.habitat.co.uk',
    theme: Themes.HabitatTheme,
    vocab: HabitatVocab,
    bolt: {
      url: `https://www.argos.co.uk/assets/bolt2/${BOLT_VERSION}/bolt-habitat.min.css`,
      namespace: 'bolt-habitat'
    },
    features: {
      taxonomy: {
        vocabId: 'PROD Habitat Navigation'
      },
      addToTrolley: {
        modal: {
          enabled: true,
          hideExtras: true,
          hideCategories: true
        }
      },
      bestSellers: {
        enabled: false
      },
      wishlist: {
        enabled: false
      },
      productList: {
        forceClothingTemplate: false
      }
    }
  },
  tu: {
    key: 'tu',
    salesChannel: 'argos',
    canonicalBase: 'https://tuclothing.sainsburys.co.uk',
    theme: Themes.TuTheme,
    vocab: HabitatVocab,
    bolt: {
      url: `https://www.argos.co.uk/assets/bolt2/${BOLT_VERSION}/bolt-tu.min.css`,
      namespace: 'bolt-tu'
    },
    features: {
      taxonomy: {
        vocabId: ''
      },
      addToTrolley: {
        modal: {
          enabled: false,
          hideExtras: false,
          hideCategories: false
        }
      },
      bestSellers: {
        enabled: false
      },
      wishlist: {
        enabled: false
      },
      productList: {
        forceClothingTemplate: true
      }
    }
  }
}
